import { OfferPage } from "@/pages/OfferPage/OfferPage";
import { getOffer } from "@/pages/OfferPage/offers";
import { createFileRoute, notFound } from "@tanstack/react-router";

export const Route = createFileRoute("/$offerSlug/")({
	loader: ({ params }) => {
		const offer = getOffer(params.offerSlug);
		if (!offer) throw notFound();
		return { offer };
	},
	component: OfferRouteComponent,
});

function OfferRouteComponent() {
	const { offer } = Route.useLoaderData();
	return <OfferPage offer={offer} />;
}
